export default "__VITE_ASSET__wVJ0_N23__"